import { useEffect, useRef } from "react";

/**
 * Generic context menu.
 * Usage:
 *   <ContextMenu x={x} y={y} items={[{label, icon, onClick, danger?, divider?}]} onClose={fn} />
 */
export function ContextMenu({ x, y, items, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const keyHandler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', keyHandler);
    return () => { document.removeEventListener('mousedown', handler); document.removeEventListener('keydown', keyHandler); };
  }, [onClose]);

  // Clamp to viewport
  const menuWidth = 200;
  const menuHeight = items.length * 36 + 16;
  const left = Math.min(x, window.innerWidth  - menuWidth  - 8);
  const top  = Math.min(y, window.innerHeight - menuHeight - 8);

  return (
    <div ref={ref} style={{
      position: 'fixed', left, top, zIndex: 9000,
      minWidth: menuWidth, padding: '6px 0',
      background: '#1a1b2e', border: '1px solid rgba(255,255,255,0.12)',
      borderRadius: 10, boxShadow: '0 12px 40px rgba(0,0,0,0.7)',
    }}>
      {items.map((item, i) => {
        if (item.divider) return <div key={i} style={{ height: 1, background: 'rgba(255,255,255,0.08)', margin: '4px 0' }} />;
        return (
          <button key={i}
            onClick={() => { item.onClick?.(); onClose(); }}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              width: '100%', padding: '7px 14px',
              background: 'none', border: 'none',
              color: item.danger ? '#f87171' : 'rgba(255,255,255,0.8)',
              fontSize: 13, cursor: 'pointer', textAlign: 'left',
              transition: 'background 0.1s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = item.danger ? 'rgba(239,68,68,0.12)' : 'rgba(99,102,241,0.15)'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >
            {item.icon && <span style={{ fontSize: 15, opacity: 0.85, flexShrink: 0 }}>{item.icon}</span>}
            <span style={{ flex: 1 }}>{item.label}</span>
            {item.shortcut && <span style={{ fontSize: 11, opacity: 0.35 }}>{item.shortcut}</span>}
          </button>
        );
      })}
    </div>
  );
}
